import React, { useState } from 'react';
import { OnboardingDialogBase } from './OnboardingDialogBase';
import { TutorialVideoEmbed } from './TutorialVideoEmbed';

export interface ITutorialVideoDialogProps {
	onClose: () => void;
	stepText?: string;
}



export const TutorialVideoDialog: React.FC<ITutorialVideoDialogProps> = ({
	onClose,
	stepText,
}) => {

	return (
		<OnboardingDialogBase
			title="Learn how to build with Elyx"
			badgeText="Recommended"
			stepText={stepText}
			onAcknowledge={onClose}
			wide={true}
		>
			<p>
				Elyx is a completely new kind of programming language. We strongly recommend watching our complete tutorial series to get started quickly.
			</p>
			
			<TutorialVideoEmbed bleedOffset={48} />
		</OnboardingDialogBase>
	);
};

export default TutorialVideoDialog;
